module.exports = __webpack_public_path__ + "static/logo-fd3e61526a0cb1273e1c91b67be730a9.png";